import React, { FC, useEffect, useState } from "react";
import CustomSpinnerComponent from "../../../../../shared/custom-spinner/custom-spinner.component";
import CustomHighChartComponent from "../../../../../shared/custom-highchart-component/custom-highchart.component";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getMotionTrafficData } from "../../../../../store/slices/asset.slice";
import { generateFilenameWithTimestamp } from "src/shared/helpers/generateFilenameWithTimestamp";

interface AssetDetailsMotionTrafficChartType {
  assetId: any;
  isRefreshed: boolean;
}

const AssetDetailsMotionTrafficChart: FC<
  AssetDetailsMotionTrafficChartType
> = ({ assetId, isRefreshed }) => {
  const dispatch = useDispatch();
  const [motionCountVsTimeData, setMotionCountVsTimeData] = useState<any>({});

  useEffect(() => {
    dispatch(getMotionTrafficData({ id: assetId }));
  }, [assetId, isRefreshed]);

  const isLoadingMotionTrafficData = useSelector((state: any) => {
    return state.asset.isLoadingMotionTrafficData;
  });

  const motionTrafficData = useSelector((state: any) => {
    return state.asset.motionTrafficData;
  });

  useEffect(() => {
    if (motionTrafficData?.data?.length) {
      /*       const isEveryMotionCountZero = motionTrafficData?.data?.every(
        (data: any) => data?.motionCount == 0
      );

      if (isEveryMotionCountZero) {
        setMotionCountVsTimeData({
          time: [],
          motionCount: [],
        });
      } else { */
      const time = motionTrafficData.data.map((d: any) => d.hour);
      // const motionCount = motionTrafficData.data.map((d: any) => d.motionCount);

      const motionCount = motionTrafficData?.data?.every(
        (d: any) => d?.motionCount == null
      )
        ? null
        : motionTrafficData?.data?.map((d: any) => d?.motionCount);

      setMotionCountVsTimeData({
        time,
        motionCount,
      });
      // }
    } else {
      setMotionCountVsTimeData({
        time: [],
        motionCount: [],
      });
    }
  }, [motionTrafficData]);

  const motionCountChartToolTipFormatter = (point: any) => {
    const { x, y } = point;

    const time =
      motionCountVsTimeData?.time?.[point.index] || point.category || x;
    return `<b>Time (Hour): </b> ${time}<br/>
            <b>Motion Count: </b> ${y} <br/>`;
  };

  return (
    <div className="mt-4 ">
      <div>
        <h4 className="h4" style={{ marginBottom: "1rem" }}>
          Motion Traffic
          <span style={{ fontSize: "16px" }}> (Last Day)</span>
        </h4>
      </div>

      <CustomSpinnerComponent
        height={"300px"}
        width={"100%"}
        isLoading={isLoadingMotionTrafficData}
      >
        <CustomHighChartComponent
          xAxisCategories={motionCountVsTimeData?.time}
          SeriesType={"areaspline"}
          seriesData={motionCountVsTimeData?.motionCount}
          seriesShowInLegend={false}
          seriesName={"Motion Count"}
          xAxisTitleText={"Time (Hour)"}
          yAxisTitleText={"Motion Count"}
          colors={["#66b2ff"]}
          containerProps={{
            style: { height: "350px", marginLeft: "-1rem" },
          }}
          fileName={generateFilenameWithTimestamp("Motion Traffic (Last Day)")}
          chartName={"Motion Traffic (Last Day)"}
          tooltipFormatter={motionCountChartToolTipFormatter}
        />
      </CustomSpinnerComponent>
    </div>
  );
};

export default AssetDetailsMotionTrafficChart;
